module.exports = __webpack_public_path__ + "static/midori-2eb3ca2a659a5d2361ffaa7f2cc0285b.png";